import React, { Component } from 'react';
import './Button.css';

export default class extends Component {
  render() {
    let icon = (this.props.withIcon) ? (<div className={`icon icon--${this.props.withIcon}`}></div>) : null;
    let iconClass = icon ? 'button--with-icon' : '';

    return (
      <div onClick={this.props.onClick} className={`button ${this.props.className} ${iconClass}`}>
        {icon}
      	<div className="button-label">{this.props.children}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Button.js